import { OhsUser } from 'user/OhsUser';
import { ModuleUrl, ModuleRoute } from 'global-services/constants/OhsRoutes';

const commonPermission = (user: OhsUser) => user?.configs?.qrcode?.PERMISSIONS?.view || false;
const createRoute = (path: string, permission: (user: OhsUser) => boolean) => ({
  path,
  url: `/${ModuleUrl.QrCode}/${path}`,
  permission,
});

const OhsQrCodeRouteList = {
  [ModuleRoute.Home]: createRoute('home', commonPermission),
  [ModuleRoute.Details]: createRoute(':qrcodeId/view', commonPermission),
  [ModuleRoute.Add]: createRoute(
    'add',
    (user) => user?.configs?.qrcode?.PERMISSIONS.create || false
  ),
  [ModuleRoute.Edit]: createRoute(
    ':qrcodeId/edit',
    (user) => user?.configs?.qrcode?.PERMISSIONS.edit || false
  ),
};

export default OhsQrCodeRouteList;
